import * as types from '@/store/types'
import constConf from '../../../constconf'
import Vue from 'vue'
import actionRequests from './actionRequests'

export default {
    productAll: (context, botId) => {
        let url = constConf.shop.url + '/card/all/' + botId
        context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => {
                if (response.ok === true) {
                    context.commit('cardAll', response.response.data)
                } else {
                    context.commit('cardAll', [])
                }
            })
    },
    changeBotIdModelDefault: (context, botId) => {
        context.commit('changeBotIdModelDefault', botId)
    },
    cardAllByCardListReturnOnly: (context, cardListId) => {
        let url = constConf.shop.url + '/card/all-by-card-list/' + cardListId
        return context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => { return response })
    },
    cardsInCardAll: (context, cardId) => {
        let url = constConf.shop.url + '/card/cards-in-card-all/' + cardId
        return context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => {
                return response
            })
    },
    cardAllByCategory: (context, categoryId) => {
        let url = constConf.shop.url + '/card/all-by-category/' + categoryId
        context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => {
                if (response.ok === true) {
                    context.commit('cardAll', response.response.data)
                } else {
                    context.commit('cardAll', [])
                }
            })
    },
    productCreate: (context, data) => {
        let method = 'post'
        let url = constConf.shop.url + '/product/create'
        if (data.id != null) {
            method = 'put'
            url = constConf.shop.url + '/product/update/' + data.id
        }
        let payload = { method: method, url: url, data: data }
        return context.dispatch('axios/queryWithData', payload, { root: true })
            .then(response => {
                if (response.ok) {
                    let functionName = { put: 'productUpdate', post: 'productCreate' }
                    context.commit(functionName[method], response.data)
                    return response
                } else {
                    return response
                }
            })
    },
    productDelete: (context, cardId) => {
        let payload = { method: 'delete', url: constConf.shop.url + '/product/delete/' + cardId }
        return context.dispatch('axios/queryWithData', payload, { root: true })
            .then(response => {
                if (response.ok) {
                    context.commit('productDelete', response.data)
                }
                return response
            })
    },
    ...actionRequests
}
